class PdpAccordion {
  #animation = null;

  constructor(item) {
    this.item = item;
    this.btn = item.querySelector('.pdp-acc__summary');
    this.body = item.querySelector('.pdp-acc__body');
    this.btn.addEventListener('click', () => this.#toggle());
  }

  #toggle() {
    if (this.#animation) this.#animation.cancel();
    this.item.classList.contains('is-open') ? this.#close() : this.#open();
  }

  #open() {
    const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;
    this.item.classList.add('is-open');
    this.btn.setAttribute('aria-expanded', 'true');
    this.#animation = this.body.animate(
      [{ height: '0px' }, { height: `${this.body.scrollHeight}px` }],
      { duration, easing: 'ease' }
    );
    this.#animation.onfinish = () => {
      this.body.style.height = 'auto';
      this.#animation = null;
    };
  }

  #close() {
    const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;
    this.#animation = this.body.animate(
      [{ height: `${this.body.scrollHeight}px` }, { height: '0px' }],
      { duration, easing: 'ease', fill: 'forwards' }
    );
    this.#animation.onfinish = () => {
      this.item.classList.remove('is-open');
      this.btn.setAttribute('aria-expanded', 'false');
      this.body.style.height = '';
      this.#animation = null;
    };
  }

  static init(root = document) {
    root.querySelectorAll('.pdp-acc__item').forEach((item) => new PdpAccordion(item));
  }
}

PdpAccordion.init();

document.addEventListener('shopify:section:load', (e) => {
  PdpAccordion.init(e.target);
});
